import React, { useEffect, useState } from "react";
import { useStoreClosure } from "../context/StoreClosureContext";

/**
 * A full-screen notice modal that appears automatically when the restaurant
 * is closed on a scheduled date (UK time). Dismissible but purely informational.
 */
export default function ClosedNoticeModal() {
  const [visible, setVisible] = useState(false);
  const { isClosed, closedReason } = useStoreClosure();

  useEffect(() => {
    if (isClosed) setVisible(true);
  }, [isClosed]);

  useEffect(() => {
    if (!visible) return;
    const onKey = (e) => {
      if (e.key === "Escape") setVisible(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
      onClick={() => setVisible(false)}
    >
      <div
        className="closed-notice-card w-full max-w-md rounded-3xl bg-white shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header accent */}
        <div className="closed-notice-header px-6 py-5 text-center text-white">
          <div className="closed-notice-icon mx-auto mb-2">🚧</div>
          <h3 className="text-xl font-extrabold tracking-tight">
            Temporarily Closed
          </h3>
        </div>

        {/* Body */}
        <div className="px-6 py-5">
          <p className="text-stone-700 text-sm leading-relaxed text-center">
            We are closed <strong>today</strong>
            {closedReason ? ` for ${closedReason}` : ""}. We apologise for any
            inconvenience and look forward to serving you again soon!
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 pb-5">
          <button
            className="closed-notice-btn w-full rounded-2xl py-3 text-white font-bold text-base transition-all"
            onClick={() => setVisible(false)}
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
